export interface NotificationSettings {
  communityPosts: boolean;
  upvotes: boolean;
  comments: boolean;
  pollVotes: boolean;
}

export type NotificationSettingKey = keyof NotificationSettings;

export interface NotificationSettingModel {
  setting: 'communityPosts' | 'upvotes' | 'comments' | 'pollVotes';
  enabled: boolean;
}

export interface NotificationItem {
  id: string;
  type: 'upvote' | 'comment' | 'poll_vote' | 'community_post' | 'exactech_news' | 'reconstruction' | 'adminNotification';
  title: string;
  message: string;
  createdAt: string;
  isRead: boolean;
  actionUrl?: string;
  actionData?: {
    postId?: number;
    commentId?: number;
    userId?: number;
  };
  actor?: {
    id: number;
    name: string;
    avatar?: string;
  };
  // GPS reconstruction notification fields
  caseId?: string;
  status?: string;
  isReconstruction?: boolean;
  sender?: {
    id?: number;
    name?: string;
  };
}

export const DEFAULT_NOTIFICATION_SETTINGS: NotificationSettings = {
  communityPosts: true,
  upvotes: true,
  comments: true,
  pollVotes: false,
};